import React, { useState, useContext, useEffect } from "react";
import "./SidebarHeader.css"; // Import CSS for styling
import NotificationBell from "./reusable/notification-bell";
import BuildHubLogo from "../images/buildhub.png";
import BuildHubLogoSmall from "../images/buildhub-small.png";
import tiger0 from "../images/tiger0.png";
import BChatLogo from "../images/buildhub-chat-logo.png";
import profileFiller from "../images/empty.jpg";

import { userLogout } from "../hooks/accountHandler";
import { useNavigate } from "react-router-dom";
import { ChatContext, WebSocketContext } from "../context/contexts";

// TODO: Replace with actual API call when admin check endpoint is available
const ADMIN_USERIDS = [
  "ccf6c88a-3611-47fc-b154-943bd6c32bd6",
  "681458ec-b6be-24.5-1473-714aaa9d48bd",
  "6684c23f-20b1-f5.1-7261-7169ed5c3123",
  "b1db3597-0d33-47b9-a14e-674d07eb0e3d",
];

function SidebarHeader(props) {
  const Chat = useContext(ChatContext);
  const WS = useContext(WebSocketContext);
  const navigate = useNavigate();

  const {
    userDetails,
    showHideChangePasswordModal,
    setPrivateMessageModalShow,
    showAiChatbot,
    setShowAiChatbot,
  } = props;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const userProfile =
    userDetails &&
    userDetails.profile_photo &&
    userDetails.profile_photo !== null &&
    userDetails.profile_photo !== ""
      ? `${process.env.REACT_APP_IMAGES_DATA_RESOURCES_URL}/${userDetails.profile_photo}`
      : profileFiller;
  const handleLogout = () => {
    userLogout();
    WS.websocketInstance.logout();
    navigate("/login");
  };
  const IS_ADMIN = userDetails && ADMIN_USERIDS.includes(userDetails.id);
  return (
    <div
      className={`sidebar-header ${
        Chat.isMobileMode && Chat.isMobileChatDetailShow
          ? "sidebar-header-hide"
          : ""
      }`}
    >
      <div className="sidebar-header__icon">
        <img
          src={BChatLogo}
          alt=""
          onClick={(e) => navigate("/")}
          className="sidebar-header-logo"
          style={{ cursor: "pointer" }}
        />
      </div>{" "}
      {/* Icon for compact design */}
      {IS_ADMIN && (
        <div className="sidebar-header__nav">
          <button
            className={`sidebar-header__nav-btn${
              showAiChatbot ? " sidebar-header__nav-btn--active" : ""
            }`}
            onClick={() =>
              setShowAiChatbot && setShowAiChatbot((prev) => !prev)
            }
            title="Tiger X AI Assistant (Admin Only)"
          >
            <img
              src={tiger0}
              alt="Tiger X AI Assistant"
              className="sidebar-header__nav-icon"
            />
          </button>
        </div>
      )}
      <div className="sidebar-header__profile-section">
        <NotificationBell addtlClass={"notif-side-header"} />
        <img
          src={userProfile}
          alt="User Profile"
          className="sidebar-header__profile-photo"
          onClick={toggleDropdown}
        />
        {isDropdownOpen && (
          <div className="sidebar-header__dropdown">
            <div
              className="sidebar-header__dropdown-item"
              onClick={(e) => navigate("/profile")}
            >
              My Profile
            </div>
            <div
              className="sidebar-header__dropdown-item"
              onClick={(e) => navigate("/requests?p=view-requests")}
            >
              My Request
            </div>
            <div
              className="sidebar-header__dropdown-item"
              onClick={(e) => showHideChangePasswordModal()}
            >
              Change Password
            </div>
            <div
              className="sidebar-header__dropdown-item"
              onClick={(e) => handleLogout()}
            >
              Logout
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SidebarHeader;
